import React from 'react';
import { Flex, Text } from '../core';
import { PnlLock, formatPercentageBN, N_A, VaultUpgradable } from '@sc1/common';
import { useLockFeeSCY } from '@sc1/common/hooks';
import { MouseoverTooltip, TooltipIcon } from '../Tooltip';

interface LockFeeInfoProps {
  vault: VaultUpgradable;
  decimals?: number;
  lockType: PnlLock;
}
export const LockFeeInfo = ({
  vault,
  decimals,
  lockType,
}: LockFeeInfoProps) => {
  const { feeBN } = useLockFeeSCY(vault, lockType);
  if (feeBN == null || feeBN.lte(0)) return null;
  const feeFmt = formatPercentageBN(feeBN, decimals);
  if (feeFmt === '0%' || feeFmt === N_A) return null;
  const enumToText = ['', 'Deposit', 'Withdraw'][lockType];
  const text = `There is a dynamic ${enumToText.toLowerCase()} fee based on price movement since the most recent harvest. Most of the time the fees are 0%.`;
  return (
    <Flex mt={1}>
      <MouseoverTooltip placement="bottom" width={400} text={text}>
        <Text variant="info">
          <TooltipIcon />
          <Text ml={1}>
            {feeFmt} {enumToText} Fee
          </Text>
        </Text>
      </MouseoverTooltip>
    </Flex>
  );
};
